import { schema } from 'normalizr';

export const productCategoryTRSchema = new schema.Entity('productCategoryTR', {}, { idAttribute: 'ProductCategoryTRId' });
export const productCategoryTRListSchema = [productCategoryTRSchema];
